import {action, makeObservable, observable} from 'mobx'
import {FormTestingRulesServiceInterface} from '../core/rules-service.interface'
import {FreeTimeException, FreeTimeSlot, TestingWeekRule} from '@/src/features/functional-testing/core/dto'
import dayjs, {Dayjs} from 'dayjs'
import {allowDay, allowDayOfWeek} from '@/src/features/functional-testing/core/date-rules'
import {settings} from '@/src/config/settings'

export type FormTestingRoutes = {
  shopRules: (shopId: Id) => string
  shopTimeSlots: (shopId: Id) => string
  save: string
}

export class FormTestingViewModel {
  rulesService: FormTestingRulesServiceInterface

  routes: FormTestingRoutes

  timeOffsetInHours = settings.TIME_ZONE_OFFSET

  @observable
  weekRules: TestingWeekRule[] = []

  @observable
  exceptions: FreeTimeException[] = []

  @observable
  freeTimeSlots: FreeTimeSlot[] = []

  constructor(rulesService: FormTestingRulesServiceInterface, routes: FormTestingRoutes) {
    this.rulesService = rulesService
    this.routes = routes

    makeObservable(this)
  }

  async getWeekRules(labId: string) {
    return await this.rulesService.getWeekRules({labId}, this.routes.shopRules)
  }

  async getTimeSlotsByLabOnDate(labId: string, date?: string) {
    if (!date) {
      const now = new Date()
      date = dayjs(now).format('YYYY-MM-DD')
    }

    return await this.rulesService.getTimeSlotsByLabOnDate({labId, date}, this.routes.shopTimeSlots)
  }

  @action.bound
  setWeekRules(weekRules: TestingWeekRule[]) {
    this.weekRules = weekRules
  }

  @action.bound
  setExceptions(exceptions: FreeTimeException[]) {
    this.exceptions = exceptions
  }

  @action.bound
  setTimeSlots(freeTimeSlots: FreeTimeSlot[]) {
    this.freeTimeSlots = freeTimeSlots
  }

  allowDay(date: Dayjs) {
    return allowDay(date, this.weekRules, this.timeOffsetInHours, this.exceptions)
  }

  allowDayOfWeek(date: Dayjs) {
    if (date.isSame(dayjs(), 'day')) {
      return allowDayOfWeek(date, this.weekRules, this.timeOffsetInHours, this.exceptions)
    }
    return allowDayOfWeek(date.startOf('day'), this.weekRules, this.timeOffsetInHours, this.exceptions)
  }
}
